import { Registry } from "scantling-common";
import type { ComponentType } from "react";

/** Props passed to each cmdk item component */
export interface CmdkItemProps {
  onClose: () => void;
}

/** A component that renders one or more CommandItem entries */
export type CmdkItemComponent = ComponentType<CmdkItemProps>;

export interface CmdkGroup {
  heading: string;
  items: CmdkItemComponent[];
}

export interface CmdkProvider {
  type: string;
  /** Hook that returns cmdk groups based on current route/context */
  useItems: () => CmdkGroup[];
}

export const cmdkRegistry = new Registry<CmdkProvider>();

export function getCmdkProviders(): CmdkProvider[] {
  return cmdkRegistry.getAll();
}
